import React, { HTMLAttributes } from 'react';
import { IconContext } from '@react-icons/all-files';
import FontAwesomeIcons from './allFontAwesomeIcons';

export type TLazyIconKey = keyof typeof FontAwesomeIcons;

export interface IFontAwesomeIcon extends HTMLAttributes<HTMLDivElement> {
  iconClassName: TLazyIconKey;
  iconContextProps?: {
    className?: string;
    style?: object;
    color?: string;
  };
}

export const FontAwesomeIcon = ({
  iconClassName,
  iconContextProps,
}: IFontAwesomeIcon) => {
  if (FontAwesomeIcons[iconClassName]) {
    const IconRequested = FontAwesomeIcons[iconClassName];
    const showIcon = () => (
      <>
        <IconRequested />
      </>
    );
    if (iconContextProps) {
      const { className = '', style = {}, color = '' } = iconContextProps;
      return (
        <IconContext.Provider value={{ color, className, style }}>
          {showIcon()}
        </IconContext.Provider>
      );
    }
    return showIcon();
  }
  return <></>;
};
